export const blockIconsCommunicationAppRegistration = (
	<span className='material-symbols-outlined'>app_registration</span>
);
